var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 37,
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "ytPfpControlsLargePlayButtonIconBg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.726 30.8327C27.2109 34.3491 22.968 36.1067 18 36.1067C13.0307 36.1067 8.78914 34.3491 5.274 30.8327C1.75757 27.3175 0 23.076 0 18.1067C0 13.1387 1.75757 8.89583 5.274 5.38069C8.78914 1.86426 13.0307 0.106689 18 0.106689C22.968 0.106689 27.2109 1.86426 30.726 5.38069C34.2424 8.89583 36 13.1387 36 18.1067C36 23.076 34.2424 27.3175 30.726 30.8327Z",
  fill: "#000",
  fillOpacity: 0.7
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.0859 18.1067L13.5 25.2784V10.935L26.0859 18.1067Z",
  fill: "#fff"
})));
export default SvgPlay;